import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@shared/api-client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      /**
       * Account data changes rarely and almost always because this tab changed
       * it, in which case the mutation invalidates the key directly.
       */
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // 4xx will not become a different answer on a retry, and retrying a 401
        // just fires the unauthorized handler repeatedly.
        if (
          error instanceof ApiError &&
          error.status >= 400 &&
          error.status < 500
        ) {
          return false;
        }

        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
